<template>
  <div class="d-flex align-items-center scrollarea">
    <div >
      <div class="flex-shrink-0 p-3 bg-sidebar" style="width: 280px" >
        <a href="/" class="align-items-center pb-3 link-dark text-decoration-none border-bottom">
          <!-- <svg class="bi pe-none me-2" width="30" height="24"><use xlink:href="#bootstrap"></use></svg> -->
        </a>
        <ul class="list-unstyled ps-0 sidebar-fixed-area sidebarScroll">
          <div class="mb-3 text-center me-5 mt-3">
            <img style="width: 150px" src="@/assets/images/logo_qnbpay.png" alt="test" />
          </div>
          <li class="mb-3">
            <router-link 
              :to="{ name: 'HomePage' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('HomePage') }
              ]"
            >
              {{ $t('navigation.home') }}
            </router-link>
          </li>

          <li class="mb-3">
            <router-link 
              :to="{ name: 'AccessUrls' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('AccessUrls') }
              ]"
            >
              {{ $t('navigation.accessUrls') }}
            </router-link>
          </li>

          <li class="mb-3">
            <router-link 
              :to="{ name: 'MerchantInformations' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('MerchantInformations') }
              ]"
            >
              {{ $t('navigation.merchantInfo') }}
            </router-link>
          </li>

          <li class="mb-3">
            <router-link 
              :to="{ name: 'TestCards' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('TestCards') }
              ]"
            >
              {{ $t('navigation.testCards') }}
            </router-link>
          </li>

          <li class="mb-3">
            <button
              :class="[
                'btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isTokenSectionActive() }
              ]"
              data-bs-toggle="collapse"
              data-bs-target="#token-collapse"
              :aria-expanded="isTokenSectionActive()"
            >
              {{ $t('navigation.tokenAndInstallment') }}
            </button>
            <div class="collapse" :class="{ 'show': isTokenSectionActive() }" id="token-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link 
                    :to="{ name: 'Tokenize' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('Tokenize') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.tokenize') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'InstallmentInformations' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('InstallmentInformations') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.installmentInfo') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'MerchantCommissionAPI' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('MerchantCommissionAPI') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.merchantCommission') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'MerchantActiveInstallments' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('MerchantActiveInstallments') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.merchantActiveInstallments') }}</div>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              :class="[
                'btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isTransactionsSectionActive() }
              ]"
              data-bs-toggle="collapse"
              data-bs-target="#transactions-collapse"
              :aria-expanded="isTransactionsSectionActive()"
            >
              {{ $t('navigation.paymentControlRefund') }}
            </button>
            <div class="collapse" :class="{ 'show': isTransactionsSectionActive() }" id="transactions-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link 
                    :to="{ name: 'HashVerify' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('HashVerify') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.hashVerify') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'SecurePayment' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('SecurePayment') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.securePayment') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'CompletePaymentAPI' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('CompletePaymentAPI') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.completePayment') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'NonSecurePayment' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('NonSecurePayment') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.nonSecurePayment') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'PayWithQNBPay' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PayWithQNBPay') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.payWithQNBPay') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'PayByToken' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PayByToken') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.payByToken') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'PayByToken3D' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PayByToken3D') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.payByToken3D') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'TransactionStatus' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('TransactionStatus') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.transactionStatus') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'PaymentVerify' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PaymentVerify') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.paymentVerify') }}</div>
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'PaymentRefund' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PaymentRefund') }
                    ]"
                  >
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>{{ $t('apiEndpoints.paymentRefund') }}</div>
                  </router-link>
                </li>
                <!-- <li>
                  <router-link :to="{ name: 'GetTransaction' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>İşlem Al</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'AllTransactions' }" class="link-dark d-inline-flex text-decoration-none rounded">
                    <div><span class="badge rounded-pill text-bg-light margin-span">POST</span>Bütün İşlemler</div>
                  </router-link>
                </li> -->
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              :class="[
                'btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isCodesSectionActive() }
              ]"
              data-bs-toggle="collapse"
              data-bs-target="#codes-collapse"
              :aria-expanded="isCodesSectionActive()"
            >
              {{ $t('navigation.statusCodes') }}
            </button>
            <div class="collapse" :class="{ 'show': isCodesSectionActive() }" id="codes-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link 
                    :to="{ name: 'ServerStatusCodes' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('ServerStatusCodes') }
                    ]"
                  >
                    {{ $t('apiEndpoints.serverStatusCodes') }}
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'ApplicationStatusCodes' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('ApplicationStatusCodes') }
                    ]"
                  >
                    {{ $t('apiEndpoints.applicationStatusCodes') }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <button
              :class="[
                'btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isWebhookSectionActive() }
              ]"
              data-bs-toggle="collapse"
              data-bs-target="#webhook-collapse"
              :aria-expanded="isWebhookSectionActive()"
            >
              {{ $t('navigation.webhook') }}
            </button>
            <div class="collapse" :class="{ 'show': isWebhookSectionActive() }" id="webhook-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link 
                    :to="{ name: 'PaymentWebHook' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('PaymentWebHook') }
                    ]"
                  >
                    {{ $t('apiEndpoints.paymentWebhook') }}
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'RefundWebHook' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('RefundWebHook') }
                    ]"
                  >
                    {{ $t('apiEndpoints.refundWebhook') }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li class="mb-3">
            <router-link 
              :to="{ name: 'PostmanCollections' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('PostmanCollections') }
              ]"
            >
              {{ $t('navigation.postmanCollection') }}
            </router-link>
          </li>
          
          <li class="mb-3">
            <router-link 
              :to="{ name: 'SampleProject' }" 
              :class="[
                'btn btn-title d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isActiveRoute('SampleProject') }
              ]"
            >
              {{ $t('navigation.sampleProject') }}
            </router-link>
          </li>

          <li class="mb-3">
            <button
              :class="[
                'btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed',
                { 'active': isPluginsSectionActive() }
              ]"
              data-bs-toggle="collapse"
              data-bs-target="#moneyTransfer-collapse"
              :aria-expanded="isPluginsSectionActive()"
            >
              {{ $t('navigation.plugins') }}
            </button>
            <div class="collapse" :class="{ 'show': isPluginsSectionActive() }" id="moneyTransfer-collapse">
              <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                <li>
                  <router-link 
                    :to="{ name: 'WooCommerce' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('WooCommerce') }
                    ]"
                  >
                    {{ $t('apiEndpoints.woocommerce') }}
                  </router-link>
                </li>
                <li>
                  <router-link 
                    :to="{ name: 'OpenCart' }" 
                    :class="[
                      'link-dark d-inline-flex text-decoration-none rounded',
                      { 'active': isActiveRoute('OpenCart') }
                    ]"
                  >
                    {{ $t('apiEndpoints.opencart') }}
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <!-- <li class="border-top my-3"></li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSidebar',
  methods: {
    isActiveRoute(routeName) {
      return this.$route.name === routeName;
    },
    isTokenSectionActive() {
      const tokenRoutes = ['Tokenize', 'InstallmentInformations', 'MerchantCommissionAPI', 'MerchantActiveInstallments'];
      return tokenRoutes.includes(this.$route.name);
    },
    isTransactionsSectionActive() {
      const transactionRoutes = [
        'HashVerify', 'SecurePayment', 'CompletePaymentAPI', 'NonSecurePayment', 
        'PayWithQNBPay', 'PayByToken','PayByToken3D', 'TransactionStatus', 'PaymentVerify', 'PaymentRefund'
      ];
      return transactionRoutes.includes(this.$route.name);
    },
    isCodesSectionActive() {
      const codesRoutes = ['ServerStatusCodes', 'ApplicationStatusCodes'];
      return codesRoutes.includes(this.$route.name);
    },
    isWebhookSectionActive() {
      const webhookRoutes = ['PaymentWebHook', 'RefundWebHook'];
      return webhookRoutes.includes(this.$route.name);
    },
    isPluginsSectionActive() {
      const pluginsRoutes = ['WooCommerce', 'OpenCart'];
      return pluginsRoutes.includes(this.$route.name);
    }
  }
};
</script>

<style scoped>
.bg-sidebar {
  background-color: #f8f9fa !important;
  min-height: calc(100vh - 0px);
  height: auto;
}

.sidebar-fixed-area {
  position: fixed;
  overflow-y: auto;
  top: 0;
  bottom: 0;
  width: 280px !important;
}

/* Active state styles */
.btn.active,
.link-dark.active {
  background-color: #d2f4ea !important;
  color: #27277e !important;
}

.btn.active:hover,
.link-dark.active:hover {
  background-color: #c2efe2 !important;
  color: #27277e !important;
}

/* Ensure active links maintain their styling */
.link-dark.active {
  text-decoration: none !important;
}

/* Hover effects for non-active items */
.btn:not(.active):hover,
.link-dark:not(.active):hover {
  background-color: #e9ecef !important;
  color: #212529 !important;
}
</style>
